import Api from '@/services/Index';

const getCalendar = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/reports/monthly-course-program', config);
}



export default {
    getCalendar,
}
